import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const inputCls = "w-full bg-slate-100 rounded-lg px-3.5 py-3 text-sm font-worksans outline-none focus:ring-2 focus:ring-[#A259FF]/40 transition-all";

export default function Login() {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next") || "/";
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Willkommen zurück, ${u.name}! 🪄`);
      navigate(u.role === "admin" ? "/admin" : next);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Anmeldung fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-4 font-worksans" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-6">
          <img src="/wizard-icon.png" alt="dealzauber" className="h-11 w-11 rounded-xl shadow-sm" />
          <span className="font-outfit font-extrabold text-xl tracking-tight">
            <span className="text-slate-900">deal</span><span className="ai-gradient-text">zauber</span>
          </span>
        </Link>
        <div className="bg-white rounded-2xl border border-slate-200 p-7 shadow-sm">
          <h1 className="font-outfit font-black text-2xl tracking-tight text-slate-900 mb-1">Anmelden</h1>
          <p className="text-sm text-slate-500 mb-6">Schön, dass du wieder da bist.</p>
          <form onSubmit={onSubmit} className="space-y-4">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-Mail" className={inputCls} data-testid="login-email" />
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Passwort" className={inputCls} data-testid="login-password" />
            <button type="submit" disabled={busy} className="w-full ai-gradient-bg text-white font-outfit font-bold rounded-xl px-6 py-3 hover:opacity-90 active:scale-95 transition-all inline-flex items-center justify-center gap-2" data-testid="login-submit">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Anmelden
            </button>
          </form>
          <p className="text-sm text-slate-500 text-center mt-5">
            Noch kein Konto? <Link to="/registrieren" className="text-[#A259FF] font-semibold">Registrieren</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
